<template>
    <div class="section">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <h1 class="mb-10">Built for Efficiency and Control</h1>
            </v-row>
            <v-row cols="12" justify="center">
                
                <v-col cols="12" md="3">

                    <v-card class="pa-4 horizontal-cards fill-height">
                        <v-card-title>
                            1. Connect data, logic, and actions
                        </v-card-title>
                        <v-card-text>
                            Send messages, store data, launch campaigns — all from automated triggers.<br/><br/>
                            Integrate APIs, CSVs, and third-party tools to make informed, data-driven decisions.<br/><br/>
                            Chain multiple automations to create complete end-to-end processes.
                        </v-card-text>
                    </v-card>

                </v-col>
                <v-col cols="12" md="3">
                    <v-card class="pa-4 horizontal-cards fill-height">
                        <v-card-title>
                            2. Full Audit Trails
                        </v-card-title>
                        <v-card-text>
                            Track every step of your automation with detailed logs. <br/><br/>
                            See exactly what triggered, what ran, and when — so nothing happens without clarity. <br/><br/>
                            Perfect for compliance, accountability, and peace of mind.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="3">
                    <v-card class="pa-4 horizontal-cards fill-height">
                        <v-card-title>
                            3. Scalable Infrastructure
                        </v-card-title>
                        <v-card-text>
                            Whether it’s a single reminder each morning or thousands of workflows firing in parallel, your automations run reliably.  <br/><br/>
                            The system scales with you, so growth never means slowdowns or bottlenecks.
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'WorkflowsEfficiency',
}
</script>

<style lang="scss">


hr {
    margin: 1em 0;
    width: 50%;
}

.horizontal-cards {
    v-card-title {
        font-size: 1.5em !important;
    }
    v-card-text {
        font-size: 1.2em !important;
    }
}
</style>